const excludeKeys = [
    'progressmatify_flexDirectionDesk',
    'progressmatify_flexDirectionTab',
    'progressmatify_flexDirectionMob',
    'progressmatify_columnGapRanges',
    'progressmatify_rowGapRanges',
    'progressmatify_columnGapUnits',
    'progressmatify_rowGapUnits',
    'progressmatify_icWidthRanges',
    'progressmatify_icWidthUnits',
    'progressmatify_flexWrapDesk',
    'progressmatify_flexWrapTab',
    'progressmatify_flexWrapMob',
    'progressmatify_alignItemsDesk',
    'progressmatify_alignItemsTab',
    'progressmatify_alignItemsMob',
    'progressmatify_justifyContentDesk',
    'progressmatify_justifyContentTab',
    'progressmatify_justifyContentMob'
];

export default excludeKeys;
